module.exports = __webpack_public_path__ + "assets/fonts/noto-emoji.woff?7690a5";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/fonts/noto-emoji.woff
// module id = 960
// module chunks = 0